/**
 * @module FE-CU19_表示地区設定画面
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU19';

export default {
  name: 'DisplayAreaSetting',
  components: {
    Header,
    ListPanel,
    MobileFooter,
    BreadCrumbList,
    PcPageTitle,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU19対象地区設定画面.対象地区設定'), //"対象地区設定",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU19対象地区設定画面.C0001'),
      //  "対象地区の設定項目を選択し、各画面から設定を行ってください。",
      id: '',
      text: '',
      src: '',
      panelTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      displayAreaList: [],
      usagePlanId: vm.$vuetify.lang.t(
        '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.利用プラン'
      ),
      customerNumber: vm.$vuetify.lang.t(
        '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.お客様番号'
      ),
      districtSplitNumber: vm.$vuetify.lang.t(
        '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.地区番号'
      ),
      districtSplitName: vm.$vuetify.lang.t(
        '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.警備先名'
      ),
      buttonList: [
        {
          id: 1,
          title: '$vuetify.FECU19対象地区設定画面.ニックネーム設定', //"ニックネーム設定",
          text: '$vuetify.FECU19対象地区設定画面.対象地区のニックネームの変更', //"対象地区のニックネームの変更",
          image: require('../../../assets/images/icon/nicknameSettings.svg'),
          url: '/setDisplayDistrictNickname',
          display: false,
        },
        {
          id: 2,
          title: '$vuetify.FECU19対象地区設定画面.IDカードキー情報設定', //"IDカード/キー情報設定",
          text: '$vuetify.FECU19対象地区設定画面.IDカード操作で表示されるユーザーの情報登録', //"IDカード操作で表示されるユーザーの情報登録",
          image: require('../../../assets/images/icon/idCardKeySettings.svg'),
          url: '/idCardKeySettings',
          display: false,
        },
        {
          id: 3,
          title: '$vuetify.FECU19対象地区設定画面.通知配信設定', //"通知配信設定",
          text: '$vuetify.FECU19対象地区設定画面.通知送信のONOFF', //"通知送信のON／OFF",
          image: require('../../../assets/images/icon/notificationDeliverySettings.svg'),
          url: '/displayDistrictNotificationDeliverySettings',
          display: false,
        },
        {
          id: 4,
          title: '$vuetify.FECU19対象地区設定画面.見守り情報配信設定', //"見守り情報配信設定",
          text: '$vuetify.FECU19対象地区設定画面.見守り情報の配信設定', //"見守り情報の配信設定",
          image: require('../../../assets/images/icon/watchOverInfoDeliverySettings.svg'),
          url: '/watchOverInfoDeliverySettings',
          display: false,
        },
        {
          id: 5,
          title: '$vuetify.FECU31各種設定画面.各種設定',
          text: '$vuetify.FECU31各種設定画面.アカウント管理_ログイン方法設定',
          image: require('../../../assets/images/header_right/settings.svg'),
          url: '/variousSettings',
          display: false,
        },
        {
          id: 6, //dummy
          title: '',
          text: '',
          image: null,
          alt: '',
          url: '/',
          display: false,
        },
      ],
      CONSTANTS: CONSTANTS,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU19対象地区設定画面.対象地区設定'), //"対象地区設定",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU19対象地区設定画面.C0001'),
        //  "対象地区の設定項目を選択し、各画面から設定を行ってください。",
        usagePlanId: vm.$vuetify.lang.t(
          '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.利用プラン'
        ),
        customerNumber: vm.$vuetify.lang.t(
          '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.お客様番号'
        ),
        districtSplitNumber: vm.$vuetify.lang.t(
          '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.地区番号'
        ),
        districtSplitName: vm.$vuetify.lang.t(
          '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.警備先名'
        ),
        buttonList: [
          {
            id: 1,
            title: vm.$vuetify.lang.t('$vuetify.FECU19対象地区設定画面.ニックネーム設定'), //"ニックネーム設定",
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU19対象地区設定画面.対象地区のニックネームの変更'
            ), //"対象地区のニックネームの変更",
            image: require('../../../assets/images/icon/nicknameSettings.svg'),
            url: '/setDisplayDistrictNickname',
            display: false,
          },
          {
            id: 2,
            title: vm.$vuetify.lang.t('$vuetify.FECU19対象地区設定画面.IDカードキー情報設定'), //"IDカード/キー情報設定",
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU19対象地区設定画面.IDカード操作で表示されるユーザーの情報登録'
            ), //"IDカード操作で表示されるユーザーの情報登録",
            image: require('../../../assets/images/icon/idCardKeySettings.svg'),
            url: '/idCardKeySettings',
            display: false,
          },
          {
            id: 3,
            title: vm.$vuetify.lang.t('$vuetify.FECU19対象地区設定画面.通知配信設定'), //"通知配信設定",
            text: vm.$vuetify.lang.t('$vuetify.FECU19対象地区設定画面.通知送信のONOFF'), //"通知送信のON／OFF",
            image: require('../../../assets/images/icon/notificationDeliverySettings.svg'),
            url: '/displayDistrictNotificationDeliverySettings',
            display: false,
          },
          {
            id: 4,
            title: vm.$vuetify.lang.t('$vuetify.FECU19対象地区設定画面.見守り情報配信設定'), //"見守り情報配信設定",
            text: vm.$vuetify.lang.t('$vuetify.FECU19対象地区設定画面.見守り情報の配信設定'), //"見守り情報の配信設定",
            image: require('../../../assets/images/icon/watchOverInfoDeliverySettings.svg'),
            url: '/watchOverInfoDeliverySettings',
            display: false,
          },
          {
            id: 5, //#27416 [機能修正管理表No.62] 「各種設定」ボタンの追加
            title: '$vuetify.FECU31各種設定画面.各種設定',
            text: '$vuetify.FECU31各種設定画面.アカウント管理_ログイン方法設定',
            image: require('../../../assets/images/header_right/settings.svg'),
            url: '/variousSettings',
            display: false,
          },
          {
            id: 6, //dummy
            title: '',
            text: '',
            image: null,
            alt: '',
            url: '/',
            display: false,
          },
        ],
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 画面遷移処理
     * @param {*} url 遷移先URL
     */
    push(url) {
      this.$router.push({
        path: url,
      });
    },
    /**
     * 表示地区設定データ取得(APP_CU1901)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU1901: async function (url, params, method) {
      this.$_setLoading(true);

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: url,
          params: params,
        })
        .then(() => {
          const apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

          this.buttonList.forEach((button) => {
            switch (button.id) {
              case 1:
                // ニックネーム設定
                button.display = apiData.contentsInfo.displayDistrictAuthority.nicknameSetting;
                break;
              case 2:
                // IDカードキー情報設定
                button.display = apiData.contentsInfo.displayDistrictAuthority.IDCardKeyInfoSetting;
                break;
              case 3:
                // 通知配信設定
                button.display =
                  apiData.contentsInfo.displayDistrictAuthority.notificationDeliverySetting;
                break;
              case 4:
                // 見守り情報配信設定
                button.display =
                  apiData.contentsInfo.displayDistrictAuthority.watchOverInfoDeliverySetting;
                break;
              case 5:
                // 各種設定
                button.display = true;
                break;
              case 6:
                // ダミー(常に非表示)
                button.display = false;
                break;
            }
          });

          // no good !!
          // バグ #30266 [ST_FE-CU19_2-1-3] 2) 2段目が非表示の時、1段目と3段目に隙間が広くなる件の修正

          if (
            this.buttonList[0].id === 1 &&
            this.buttonList[0].display === false &&
            this.buttonList[1].id === 3 &&
            this.buttonList[1].display === false
          ) {
            this.buttonList.splice(0, 2);
          }
          if (
            this.buttonList[0].id === 2 &&
            this.buttonList[0].display === false &&
            this.buttonList[1].id === 4 &&
            this.buttonList[1].display === false
          ) {
            this.buttonList.splice(0, 2);
          }
          if (
            this.buttonList[2]?.id === 2 &&
            this.buttonList[2]?.display === false &&
            this.buttonList[3]?.id === 4 &&
            this.buttonList[3]?.display === false
          ) {
            this.buttonList.splice(2, 2);
          }
          const targetItem = apiData.contentsInfo.displayDistrictInfo;
          const labels = {
            usagePlan: '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.利用プラン', //"利用プラン",
            customerNumber: '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.お客様番号', //"お客様番号",
            securityDestinationName:
              '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.警備先名', //"警備先名",
            districtSplitNumber: '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.地区番号', //"地区番号",
            districtSplitName: '$vuetify.FECU19対象地区設定画面.対象地区詳細表示領域.地区名', //"地区名",
          };
          const targetKeys = [
            'usagePlan',
            'customerNumber',
            'securityDestinationName',
            'districtSplitNumber',
            'districtSplitName',
          ];
          const planTitles = {
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
              '$vuetify.コード.利用プランID.オンライン監視プラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
              '$vuetify.コード.利用プランID.依頼かけつけプラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
              '$vuetify.コード.利用プランID.依頼かけつけプラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
              '$vuetify.コード.利用プランID.セルフ監視プラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
              '$vuetify.コード.利用プランID.セルフ監視プラン',
          };
          Object.keys(targetItem).map((key, index) => {
            if (targetKeys.includes(key)) {
              let text = targetItem[key];
              if (key === 'usagePlan') {
                text = planTitles[targetItem[key]];
              }
              if (key === 'districtSplitNumber') {
                if (targetItem[key] === '') {
                  return;
                }
                if (targetItem[key] === '    ') {
                  text = '$vuetify.FECU19対象地区設定画面.メイン地区';
                }
              }
              this.displayAreaList = [
                ...this.displayAreaList,
                {
                  id: index,
                  title: labels[key],
                  text: text,
                  isVuetifyKey: text.includes('$'),
                },
              ];
            }
          });

          this.panelTitle = {
            place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
            type: '$vuetify.FECU19対象地区設定画面.対象地区',
            typeIsBefore: true,
          };
        })
        .catch((error) => {
          this.$_abnormality(error.response.status);
        })
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * PC/スマホ間でのボタン表示方式切り替え処理
     */
    changeButtonListForPc() {
      // very very no good !!! follow original ......
      // やりたいこと
      // PC表示
      // [idx0,id:1] ニックネーム  [idx2,id:3] 通知配信
      // [idx1,id:2] IDカード     [idx3,id:4] 見守り
      // [idx4,id:5] 各種設定     [idx5,id:6] ダミー
      // の配列を以下の順番にしたい
      // [idx0,id:1] ニックネーム
      // [idx1,id:3] 通知配信 ★
      // [idx2,id:2] IDカード ★
      // [idx3,id:4] 見守り
      // [idx4,id:5] 各種設定
      // [idx5,id:6] ダミー

      let IDCardKeyInfoSetting = null;
      if (this.buttonList[1].id === 2) {
        IDCardKeyInfoSetting = this.buttonList[1];
      }
      let notificationDeliverySetting = null;
      if (this.buttonList[2].id === 3) {
        notificationDeliverySetting = this.buttonList[2];
      } else if (this.buttonList[0].id === 3) {
        notificationDeliverySetting = this.buttonList[1];
      }

      //ummm very very no good !!! follow original ......
      if (IDCardKeyInfoSetting) {
        this.buttonList.splice(1, 1, notificationDeliverySetting);
      }
      if (notificationDeliverySetting) {
        if (IDCardKeyInfoSetting) {
          this.buttonList.splice(2, 1, IDCardKeyInfoSetting);
        } else {
          this.buttonList.splice(0, 1, IDCardKeyInfoSetting);
        }
      }
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    if (this.$mq === 'pc') {
      this.changeButtonListForPc();
    }

    //何故か、以下通信でローディングマークを出してるので、ここで画面表示
    this.isShowPage = true;

    const endpoint = '/api/displayDistrictSettings/init';
    // let endpoint = "post";

    const method = 'post';
    const params = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };

    await this.APP_CU1901(endpoint, params, method);
  },
};
